import Vue from "vue";
import base from "../../baseMarketing";

export default Object.assign(
  {
    apiUrl: "/whatsapp",

    get({ messageId }) {
      const url = this.userUrl({ path: `/${messageId}` });

      return Vue.http.get(url);
    },

    list({ page, isAutomation, filter }) {
      const url = this.userUrl({ path: `/${page}/list` });

      return Vue.http.get(url, {
        params: {
          isAutomation,
          filter
        }
      });
    },
  },
  base
);
